import { useState, useEffect } from 'react';
import { getDatasets } from '../config/services/datasets';
import { addPreAgg,deletePreAgg } from '../config/services/preAggregation';
import { styled,makeStyles } from '@mui/styles';
import moment from 'moment';
import toast from 'react-hot-toast';
import {
  List,Modal,Fade, ListItemIcon, ListItemButton, ListItemText,ListSubheader, ListItem, Typography, TextField, Box, Select, MenuItem, Button,Grid, Stack,FormControl,InputLabel, Autocomplete,FormControlLabel,Checkbox
} from '@mui/material';
import { EncryptData, DecryptData } from "../utils/encryptDecrypt";
import Env_Config, { getRandomName } from '../config/settings'
import { LoadingButton } from '@mui/lab';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import SvgIcon from "@mui/material/SvgIcon";
import AddIcon from '@mui/icons-material/Add';
import { Icon } from '@iconify/react';
import DateRangeIcon from '@mui/icons-material/DateRange';
import hashFill from '@iconify/icons-eva/hash-fill';
import EditIcon from "../assets/icons/icon_edit.svg";
import TrashIcon from '../assets/icons/icon_trash.svg';
import { ReactComponent as DropDownIcon } from "../assets/icons/icon-angle-down.svg";
import { ReactComponent as VisualizeIcon } from "../assets/icons/icon-visualize.svg"
import { Link } from "react-router-dom";
import { universalRegex } from '../helper/calculatedFunctions'


const DRAWER_WIDTH = 380;
const RootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
})
const MainStyleWrapper = styled('div')(({ theme }) => ({
    height: '100%',
    width: '100%'
}))
const useStyles = makeStyles((theme) => ({
    grow: {
      flexGrow: 1,
    },
    title: {
      color: '#202124',
      fontSize: '22px',
    },
    subtitle: {
      fontSize: '14px',
      color: '#202124',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
    headingButton: {
      display: 'block',
      width: '100%',
    },
    headingIcon: {
      display: 'flex',
      '&:hover': {
        background: 'none',
      },
    },
    reportHeader: {
      background: 'transparent',
      boxShadow: 'none',
      // borderBottom: '1px solid #DEDEDE',
    },
    button: {
      color: '#202124',
      fontWeight: 'normal',
      '&:hover': {
        background: 'none',
      },
      marginLeft: 0,
      paddingLeft: 0,
    },
    headingButtonWrap: {
      width: '90%',
      float: 'right',
      padding: '0 1rem',
      '&:hover': {
        backgroundColor: '#f45e29',
      },
      ['@media (max-width:1700px)']: {
        padding: '0 0.5rem',
        width: '95%',
        lineHeight: '16px',
        textAlign: 'center',
      },
      ['@media (max-width:1400px)']: {
        padding: '0.2rem 0.5rem',
        width: '95%',
        textAlign: 'center',
        lineHeight: '16px',
      },
      ['@media (max-width: 1199px)']: {
        float: 'left',
      }
    },
    headerButtons: {
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start'
      },
    },
    menuDropdownItem: {
      fontSize: '14px',
      color: '#202124',
      '&:hover': {
        backgroundColor: '#f6f6f6'
      }
    },
    fieldMenu: {
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
      },
      autoCompleteInp: {
        fontWeight: 'normal'
      },
      fieldBtn: {
        position: 'absolute',
        right: '5px',
        bottom: '3px',
        cursor: 'pointer',
        minWidth: 'auto',
      },
      reportFieldList: {
        width: '100%',
        backgroundColor: '#fff',
        maxHeight: '350px',
        minHeight: '350px',
        marginBottom: '1rem',
        overflow: 'auto',
        marginTop: '5px',
        borderRadius: '4px',
      },
      bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
      },
      formInput: {
        paddingLeft: 0,
        '&::placeholder': {
          paddingLeft: '-10px',
        }
      },
      searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
          background: "#f1f1f1",
          zIndex: 9,
          "& $listItemDescription": {
            visibility: 'visible'
          },
          "& $searchFieldListMoreIcon": {
            visibility: 'visible'
          }
        },
    
      },
      listItemDescription: {
        visibility: 'hidden',
        '&:hover': {
          visibility: 'visible'
        }
      },
      searchFieldListMoreIcon: {
        visibility: 'hidden',
        '&:hover': {
          visibility: 'visible'
        }
      },
      drawerPaper: {
        width: DRAWER_WIDTH,
        backgroundColor: '#fff',
    },
    reportSettings: {
        width: '100%',
        height: '100%',
        backgroundColor: '#FFE9E2',
        padding: '1rem',
        borderRadius: '8px',
        [theme.breakpoints.between("lg", "xl")]: {
            padding: '0.5rem',
        },
        [theme.breakpoints.down("lg")]: {
            padding: '0.5rem',
        },
        [theme.breakpoints.down("sm")]: {
            padding: '0.5rem 0.5rem 0.5rem',
        },
    },
    settingsBox: {
        width: '100%',
    },
    drawerOpen: {
        width: DRAWER_WIDTH,
    },
    drawerClosed: {
    },
    grey_bg:{
      backgroundColor: '#f1f1f1',
    },
    codeBg:{fontSize: '12px',padding: '0 0 0 40px',fontWeight: 500,color: '#474646'}
}));
const ParseSvgIcon = ({ component }) => <SvgIcon component={component} width={100} height={100} />
export default function Preagg(props){
    const classes = useStyles();
    const [datasets,setDatasets] = useState([])
    const [currentDataset, setCurrentDataset] = useState({})
    const [dimensions,setDimensions] = useState([])
    const [tagList,setTagList] = useState([])
    const [measures,setMeasures] = useState([])
    const [preaggs,setPreaggs] = useState([])
    const [editFlag,setEditFlag] = useState(false)
    const [errFlag,setErr] = useState('')
    const [editObj,setEditObj] = useState(Env_Config.defaultPreaggObj)
    const [isSubmitting,setSubmitting] = useState(false)
    const [deletePopup,setDeleteFlag] = useState(false)
    const [deleteObj,setDeleteObj] = useState({})


    useEffect(() => fetchDatasets(), [])
    
    const fetchDatasets = () => {
      const params = { pageNo: 0, sortKey: 'displayName', sortOrder: 1 }
      getDatasets(params).then(
        (res) => {
          //console.log('Dataset Response',res)
          let datsetOptionsArray = [...res.result]
          handleInitialization(datsetOptionsArray,'')              
        }
      ).catch(
        (err) => {
          console.log(err)
        }
      )
    }

    const handleInitialization = (datasets,defaultDataset) => {
      let datsetOptionsArray = datasets.map(obj => {
        return {
          label: obj?.displayName ?? obj?.dataSetName,
          dataSetName: obj?.displayName ?? obj?.dataSetName,
          description: obj?.dataSetDescription || obj?.description,
          ...obj
        }
      })
      setDatasets(datsetOptionsArray)

      // Select Default Dataset
      let firstDataSet = {}
      if(defaultDataset){
        firstDataSet = datsetOptionsArray.find(obj => obj._id == defaultDataset)
      }else{
        firstDataSet = datsetOptionsArray[0]
      }
      
      firstDataSet.measures = firstDataSet.measures.map(obj => {
        if(!obj.displayName){
          obj['displayName'] = obj.name
        }
        return obj
      }).sort((a,b) => a.displayName.localeCompare(b.displayName))

      firstDataSet.dimensions = firstDataSet.dimensions.map(obj => {
        if(!obj.displayName){
          obj['displayName'] = obj.name
        }
        return obj
      }).sort((a,b) => a.type.localeCompare(b.type) || a.displayName.localeCompare(b.displayName))
      
      let tagList = firstDataSet.dimensions.map(obj => {
        return {label:obj.displayName,name:obj.name}
      }).sort((a,b) => a.label.localeCompare(b.label))
      setTagList(tagList)
      setCurrentDataset(firstDataSet)
      setMeasures(firstDataSet.measures)
      setDimensions(firstDataSet.dimensions)
      setPreaggs(firstDataSet.preaggregations)          
      setEditFlag(false)
    }

    const getNonAdditiveMeasures = (measures, measure, dataSetName, foundMeasures) => {
      let fields = measure.sql.replace(universalRegex,'#').split('#').map(n => n.trim()).filter(n => isNaN(parseFloat(n))).filter(String)
      fields = measures.filter(obj => fields.indexOf(obj.name) >= 0)
      
      if (fields.length) {
          fields = fields.map(obj => obj.name)
          for (let rec of fields) {
              let mes = measures.find(obj => obj.name == rec)
              if (mes) {
                  foundMeasures = getNonAdditiveMeasures(measures, mes, dataSetName, foundMeasures)
              }
          }
      } else {
        foundMeasures.add(`${dataSetName}.${measure.name}`)
      }
      return foundMeasures
    }

    const handleDataSetChange = (e,value) => {
      //console.log(value)
      setCurrentDataset(value)
      setErr('')
      handleInitialization(datasets,value._id)
    }

    const handleCollapse = (index) => {
      let preAggList = preaggs.map((obj,i) => {        
        if(index == i){
          obj['isVisible'] = !obj['isVisible']
        }else{
          obj['isVisible'] = false
        }
        return obj
      })
      setPreaggs(preAggList)
    }

    const handleEditPreagg = (index) => {
      setEditFlag(true)
      setErr('')
      setEditObj(preaggs[index])
    }

    const handleDeletePreagg = (index) => {
      setDeleteFlag(true)
      setDeleteObj(preaggs[index])
    }

    const confirmDeletePreagg = () => {
      setErr('')      
      //let deleteObj = preaggs[deletePopup]
      deletePreAgg({preAggId:deleteObj._id}).then(
        res => {
          let dataSets = datasets.map(obj => {
            if(obj._id == currentDataset._id){
              let afterDelObj = obj.preaggregations.filter(obj => obj._id != deleteObj._id)
              obj.preaggregations = afterDelObj          
            }
            return obj
          })
          handleInitialization(dataSets,currentDataset._id)
          setDeleteObj({})
          setDeleteFlag(false)
          toast.success('Preaggregation Deleted Successfully')
        }
      ).catch(
        err => {
          console.log(err)
          toast.error('Some error occurred, Please try again later')
        }
      )
    }

    const handleIndexChange = (e,obj) => {
      setErr('')
      editObj['indexes'] = obj.map(obj => obj.name)
      setEditObj({...editObj})
    }

    const handleChange = (e,fieldType) => {
      console.log(fieldType)
      setErr('')
      switch(fieldType){
        case 'timeDimensionReference':
          editObj[fieldType] = `${currentDataset.dataSetName}.${e.target.value}`
          editObj['granularity'] = 'day'
          editObj['partitionGranularity'] = 'month'
          break;
        default:
          editObj[fieldType] = e.target.value
          break;
      }
      setEditObj({...editObj})
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      setSubmitting(true)
      if(editObj.measureReferences && editObj.dimensionReferences && (editObj.measureReferences.length > 0 || editObj.dimensionReferences.length > 0)){
        if(!editObj._id){
          editObj['name'] = getRandomName()
          editObj['dataSetId'] = currentDataset._id
        }
        let checkIndex = editObj.indexes.filter(obj => !editObj.dimensionReferences.includes(`${currentDataset.dataSetName}.${obj}`))
        if(checkIndex.length > 0){
          setSubmitting(false)
          setErr('Fields inside the indexes, must be selected in dimensions list')
          return false
        }
        switch(editObj.refreshKeyValue){
          case 'dynamic':
            let dimensionNames = dimensions.map(obj => obj.name)
            if(dimensionNames.indexOf('syncDate')>=0){
              let sql = ''
              let tableName = currentDataset.primaryTable?currentDataset.primaryTable:currentDataset.tableName
              sql = `SELECT MAX(sync_date) as PreaggRefreshKey FROM ${currentDataset.databaseName}.${tableName}`              
              editObj['refreshKey'] = {sql:sql}
            }else{
              editObj['refreshKey'] = Env_Config.defaultRefreshObj
            }          
            break;
          default:          
            editObj['refreshKey'] = Env_Config.defaultRefreshObj
            break;
        }
        addPreAgg(editObj).then(
          res => {
            setSubmitting(false)
            let dataSets = datasets.map(obj => {
              if(obj._id == currentDataset._id){
                if(editObj._id){
                  let editPreaggIndex = obj.preaggregations.findIndex(obj => obj._id === editObj._id)                  
                  obj.preaggregations[editPreaggIndex] = res.result.result
                  toast.success('Preaggregation Updated Successfully')
                  //console.log(preaggList,obj)
                }else{
                  obj.preaggregations.push(res.result.result)
                  toast.success('Preaggregation Added Successfully')
                }                
              }
              return obj
            })
            handleInitialization(dataSets,currentDataset._id)     
          }
        ).catch(
          err => {
            setSubmitting(false)
            toast.error('Some error occurred, Please try again later')
            console.log('Add Preagg',err)
          }
        )
      }else{
        setErr('Please select some measures & dimensions for preaggregation to build')
        setSubmitting(false)
      }      
    }

    const onSearchMeasure = (e) => {
      let searchStr = e.target.value.toUpperCase()
      let measList = []
      let dimList = []
      if(searchStr){
        measList = currentDataset.measures.filter(o => o.displayName.toUpperCase().includes(searchStr) || o.name.toUpperCase().includes(searchStr)).sort((a,b) => a.displayName.localeCompare(b.displayName))
        dimList = currentDataset.dimensions.filter(o => o.displayName.toUpperCase().includes(searchStr) || o.name.toUpperCase().includes(searchStr)).sort((a,b) => a.type.localeCompare(b.type) || a.displayName.localeCompare(b.displayName))
      }else{
        measList = currentDataset.measures.sort((a,b) => a.displayName.localeCompare(b.displayName))
        dimList = currentDataset.dimensions.sort((a,b) => a.type.localeCompare(b.type) || a.displayName.localeCompare(b.displayName))
      }
      setMeasures(measList)
      setDimensions(dimList)
    }

    const onMeasureChange = (e,type) => {  
      setErr('')    
      let selectedValue = `${currentDataset.dataSetName}.${e.target.value}`
      switch(type){
        case 'measure':
          let measureFields = new Set()
          let measure = currentDataset.measures.find(obj => obj.name == e.target.value)
          let additiveMeasures = getNonAdditiveMeasures(currentDataset.measures,measure,currentDataset.dataSetName,measureFields)
          additiveMeasures.add(selectedValue)
          if(e.target.checked){
            editObj['measureReferences'] = editObj.measureReferences?[...additiveMeasures,...editObj?.measureReferences]:[...additiveMeasures]
          }else{
            editObj.measureReferences = editObj?.measureReferences.filter(obj => [...additiveMeasures].indexOf(obj) < 0)
          }
          setEditObj({...editObj}) 
          break;
        default:
          if(e.target.checked){
            editObj['dimensionReferences'] = editObj.dimensionReferences?[...editObj?.dimensionReferences,selectedValue]:[selectedValue]
          }else{
            editObj.dimensionReferences = editObj?.dimensionReferences.filter(obj => obj != selectedValue)
          }
          setEditObj({...editObj}) 
          break;
      }
    }

    const onCancel = ( )=> {
      setErr('')
      setEditObj(Env_Config.defaultPreaggObj)
      setEditFlag(false)
    }

    const onAddPreagg = () => {
      setErr('')
      setEditObj(Env_Config.defaultPreaggObj)
      setEditFlag(true)
    }

    const handleRefreshKey = (e) => {
      let type = e.target.value
      editObj['refreshKeyValue'] = type      
      setEditObj({...editObj})
    }

    const handleCancelDelete = () => {
      setDeleteFlag(false)
      setDeleteObj({})
    }

    return (
        <RootStyle>
            <MainStyleWrapper className="report-new-wrapper">
                <Grid container spacing={2} className="report-new-content" >
                    <Grid item xs={12} md={4} className="report-new-main-fields" alignItems="stretch"  >
                    <div className={classes.reportSettings}>
                        <Box width="100%" height="100%">
                            <div className='report-settings-drawer'>
                                <Box>
                                    <Typography className="report-form-label font-weight-normal" variant="subtitle1" display="block"> Dataset </Typography>
                                    <Autocomplete
                                      className="cm_rprt_setting_content report_form_ui_input_select pl-0 report_search_visual_dataset"
                                      classes={{ input: classes.autoCompleteInp }}
                                      size='small'
                                      ListboxProps={{
                                        className: "visual-dataset-list"
                                      }}
                                      disablePortal
                                      disableClearable
                                      popupIcon={<Box className="form_icon"><DropDownIcon /></Box>}
                                      onChange={handleDataSetChange}
                                      value={currentDataset?._id ? currentDataset : null}
                                      options={datasets}
                                      isOptionEqualToValue={(option) => option._id === currentDataset._id}
                                      renderInput={(params) => <TextField {...params} />}
                                      renderOption={(props, obj) => {
                                        return (
                                          <ListItem {...props} value={obj._id} button
                                            className={classes.searchFieldListItem + " report-list-item"} alignItems="flex-start"
                                            disabled={currentDataset?._id === obj._id ? true : false}
                                          >
                                            <ListItemIcon sx={{ mt: '4px', mr: '8px' }}> <ParseSvgIcon component={VisualizeIcon} /> </ListItemIcon>
                                            <Grid container >
                                              <Grid item xs={12}>
                                                <Typography variant="body2" className="text-plain"> {obj?.displayName ? obj?.displayName : obj?.dataSetName} </Typography>
                                              </Grid>
                                              <Grid item xs={12} className="text-sub-grid">
                                                <Typography variant="subtitle2" className="text-sub"> {obj.description ?? 'No description'} </Typography>
                                              </Grid>
                                            </Grid>
                                          </ListItem>
                                        )
                                      }}
                                    />
                                    {
                                      editFlag && (
                                        <div fullWidth="true">
                                          <TextField className="cm_rprt_setting_content report_form_ui_input report_input_field_list" fullWidth="true" sx={{mt:1}} placeholder="Search Fields" type='text' onKeyUp={onSearchMeasure}/>
                                          <div className={classes.reportFieldList}>
                                            <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
                                              MEASURES
                                            </ListSubheader>                                          
                                            <List>                                        
                                              {
                                                measures.length > 0 ? measures.map(
                                                  (obj,i) => (
                                                    !obj.isHidden && (
                                                      <ListItemButton sx={{ml:0.5}} key={obj._id}>
                                                        <FormControlLabel fullWidth="true" control={<Checkbox value={obj.name} onChange={(e)=>onMeasureChange(e,'measure')} checked={editObj?.measureReferences?.indexOf(`${currentDataset.dataSetName}.${obj.name}`) > -1?true:false}/>} label={<div fullWidth="true" style={{display:"inline-flex",verticalAlign:"middle"}}><FunctionsOutlinedIcon className="cm_dimension_icon" /><ListItemText primary={obj.displayName}/></div>} /> 
                                                      </ListItemButton>
                                                    )                                                    
                                                  )
                                                ):<ListItemButton><ListItemText primary="No Measures Found"/></ListItemButton>
                                              }
                                            </List>
                                            <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
                                              DIMENSIONS
                                            </ListSubheader>
                                            <List>                                        
                                              {
                                                dimensions.length > 0 ? dimensions.map(
                                                  (obj,i) => (
                                                    <ListItemButton key={obj._id}>
                                                      <FormControlLabel fullWidth="true"
                                                        control={<Checkbox value={obj.name} onChange={(e)=>onMeasureChange(e,'dimension')} checked={editObj?.dimensionReferences?.indexOf(`${currentDataset.dataSetName}.${obj.name}`) > -1} />} 
                                                        label={
                                                          <div fullWidth="true" style={{display:"inline-flex",verticalAlign:"middle"}}>
                                                            {obj.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : obj.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                                                            <ListItemText sx={{ml:0.5}} primary={obj.displayName}/>
                                                          </div>
                                                        }
                                                      />
                                                    </ListItemButton>
                                                  )
                                                ):<ListItemButton><ListItemText primary="No Dimension Found"/></ListItemButton>
                                              }
                                            </List>
                                          </div>                                                                               
                                        </div>
                                      )
                                    }
                                </Box>
                            </div>
                        </Box>
                    </div>
                    </Grid>
                    <Grid item xs={12} md={8} className="report-new-main-content" alignItems="stretch"  >
                        <Grid className="report-new-main-content-section" sx={{ height: '100%' }}>                            
                            <div className='report-settings-drawer'>
                                <Box>
                                    {
                                      editFlag && (
                                        <Box>
                                          <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
                                            {editObj.name?`Edit Preaggregation (${editObj.name})`:'Add Preaggregation'}
                                          </ListSubheader>
                                          <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                                              <Stack alignContent="center" justifyContent="space-between" width="70%">                                              
                                                  <FormControl fullWidth="true" sx={{mt:2}}>
                                                    <InputLabel >Type</InputLabel>
                                                    <Select onChange={e=>handleChange(e,'type')} label="Type" value={editObj.type?editObj.type:'rollup'}>
                                                      {
                                                        Env_Config.PREAGG_TYPE.map(
                                                          option => (
                                                            <MenuItem value={option}>{option}</MenuItem>
                                                          )
                                                        )
                                                      }
                                                    </Select>
                                                  </FormControl>
                                                  <TextField label="Measures" value={editObj.measureReferences?editObj.measureReferences.join('\n'):''} fullWidth="true" multiline minRows={4} InputProps={{readOnly: true}} sx={{mt:2}}/>
                                                  <TextField label="Dimensions" value={editObj.dimensionReferences?editObj.dimensionReferences.join('\n'):''} fullWidth="true" multiline minRows={4} InputProps={{readOnly: true}} sx={{mt:2}}/>                                                  
                                                  <Autocomplete 
                                                    id="tags-outlined"
                                                    disablePortal
                                                    filterSelectedOptions
                                                    multiple
                                                    onChange={handleIndexChange}
                                                    popupIcon={<Box className="form_icon"><DropDownIcon /></Box>}
                                                    defaultValue={editObj.indexes?tagList.filter(obj => editObj.indexes.indexOf(obj.name)>-1):[]}
                                                    options={tagList}
                                                    renderInput={(params) => <TextField {...params} label="Indexes"/>}
                                                    onKeyPress={(e) => ( e.key === 'Enter' && e.preventDefault() )}
                                                    sx={{mt:2}}
                                                    disableClearable
                                                  />
                                                  <FormControl fullWidth="true" sx={{mt:2}}>
                                                    <InputLabel >Refresh Key</InputLabel>
                                                    <Select onChange={handleRefreshKey} label="Refresh Key" value={editObj.refreshKeyValue?editObj.refreshKeyValue:''}>
                                                      {
                                                        Env_Config.REFRESH_KEY.map(
                                                          option => (
                                                            <MenuItem value={option}>{option}</MenuItem>
                                                          )
                                                        )
                                                      }
                                                    </Select>
                                                  </FormControl>
                                                  <FormControl fullWidth="true" sx={{mt:2}}>
                                                    <InputLabel >Time Dimension</InputLabel>
                                                    <Select onChange={e=>handleChange(e,'timeDimensionReference')} label="Time Dimension" value={editObj.timeDimensionReference?editObj.timeDimensionReference.split('.')[1]:''} >
                                                      {
                                                        currentDataset.dimensions.filter(obj => obj.type == 'time').map(
                                                          obj => (
                                                            <MenuItem value={obj.name}>{obj.displayName}</MenuItem>
                                                          )
                                                        )
                                                      }
                                                    </Select>
                                                  </FormControl>
                                                  {
                                                    editObj.timeDimensionReference && (
                                                      <Box>
                                                        <FormControl fullWidth="true" sx={{mt:2}}>
                                                          <InputLabel >Granularity</InputLabel>
                                                          <Select onChange={e=>handleChange(e,'granularity')} label="Granularity" value={editObj.granularity?editObj.granularity:''}>
                                                            {
                                                              Env_Config.GRANULARITY.map(
                                                                option => (
                                                                  <MenuItem value={option}>{option}</MenuItem>
                                                                )
                                                              )
                                                            }
                                                          </Select>
                                                        </FormControl>                                               
                                                        <FormControl fullWidth="true" sx={{mt:2}}>
                                                          <InputLabel >Partition Granularity</InputLabel>
                                                          <Select onChange={e=>handleChange(e,'partitionGranularity')} label="Partition Granularity" value={editObj.partitionGranularity?editObj.partitionGranularity:''}>
                                                            {
                                                              Env_Config.GRANULARITY.map(
                                                                option => (
                                                                  <MenuItem value={option}>{option}</MenuItem>
                                                                )
                                                              )
                                                            }
                                                          </Select>
                                                        </FormControl>
                                                      </Box>
                                                    )
                                                  }                                            
                                              </Stack>
                                              {errFlag && <div fullWidth="true" className="error">{errFlag}</div>}
                                              <Grid width={'70%'} alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                                                <LoadingButton mt={2} size="large" type="submit" variant="contained" loading={isSubmitting}>Save</LoadingButton>
                                                <Button size="large" sx={{ml:1}} onClick={onCancel} variant="outlined">Cancel</Button>
                                              </Grid>
                                            </form>
                                        </Box>
                                      )
                                    }
                                    {
                                      !editFlag && (
                                        <Box>
                                          <ListSubheader className={classes.grey_bg} component="h2" id="nested-list-subheader">
                                            Preaggregations List
                                            <Button onClick={onAddPreagg} style={{float:'right'}}><AddIcon className="cm_measr_lbl"/>Add</Button>
                                          </ListSubheader>
                                          <List component="nav" sx={{width: '100%', bgcolor: 'background.paper'}}>
                                            {preaggs && preaggs.length > 0 ? preaggs.map(
                                                (obj,i) => (
                                                  <div>
                                                    <ListItemButton key={obj._id}  sx={{ pl: 4 }} id={obj._id}>
                                                      <ListItemText primary={obj.name} />
                                                      <Link to="" onClick={e=>handleEditPreagg(i)}>
                                                        <img alt='' src={EditIcon} />
                                                      </Link> 
                                                      <Link to="" style={{marginLeft:10,marginRight:5}} onClick={e=>handleDeletePreagg(i)}>
                                                        <img src={TrashIcon} alt="" />
                                                      </Link>                                             
                                                      {obj.isVisible?<ExpandLess onClick={e=>handleCollapse(i)}/>:<ExpandMore onClick={e=>handleCollapse(i)}/>}                                                
                                                    </ListItemButton>
                                                    {
                                                      obj.isVisible && (
                                                        <pre className={classes.codeBg}>
                                                          {JSON.stringify(obj,null,4)}
                                                        </pre>
                                                      )
                                                    }
                                                  </div>                                         
                                                )
                                              ):<ListItemButton><ListItemText primary="No Preaggregations Available"/></ListItemButton>
                                            }
                                          </List>
                                        </Box>
                                      )
                                    }
                                    
                                </Box>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className="modal-root"
                  open={deletePopup}
                  closeAfterTransition
                >
                  <Fade in={deletePopup}>
                    <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
                      <Box className="modal-content-simple">
                        <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this Preaggregation?`}</Typography>
                        <Box className="modal-footer-simple">
                          <Button onClick={handleCancelDelete} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                          <Button onClick={confirmDeletePreagg} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Fade>
                </Modal>
            </MainStyleWrapper>
        </RootStyle>
    )
}